<template>
  <v-row>
    <v-col cols="12" md="6" align="stretch" height="auto">
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0"
        align="stretch"
        height="auto"
      >
        <v-card-title dense>
          Proyecciones ROI CX
        </v-card-title>

        <v-row align="stretch">
          <v-col cols="12">
            <v-simple-table dense light>
              <template v-slot:default>
                <thead style="background-color: #3fa9be; color: white;">
                  <tr>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-left"
                          v-on="on"
                          style="width: 20%; color: white !important;"
                        >
                          Grupo
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna se clasifican a tus clientes en
                        <br />grupos según cómo puntuaron la encuesta: <br />Los
                        Detractores son los que califican de 0 a 6. <br />Los
                        Neutros son los que califican con 7 y 8. <br />Loa
                        Promotores los que califican con 9 y 10.
                      </span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-left"
                          v-on="on"
                          style="color: white !important;"
                        >
                          Fact. Promedio
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna tenés que completar la facturación
                        promedio
                        <br />mensual por cliente perteneciente a cada grupo.
                      </span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-left"
                          v-on="on"
                          style="color: white !important;"
                        >
                          Cantidad
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna ingresá la cantidad de clientes
                        <br />que pertenecen a cada grupo.
                      </span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-left"
                          v-on="on"
                          style=" color: white !important;"
                        >
                          Costo
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna ingresá el costo promedio mensual
                        <br />por cliente perteneciente a cada grupo.
                      </span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-left"
                          v-on="on"
                          style="color: white !important;"
                        >
                          % Mejora
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna ingresá en porcentaje de clientes
                        <br />de cada grupo que esperás que pasen al grupo
                        siguiente.
                      </span>
                    </v-tooltip>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in datos_roi" :key="item.id">
                    <td class="ma-0 pa-0 text-center">{{ item.nps }}</td>
                    <td
                      class="ma-0 pa-0"
                      @click="mostrarInput(index, 1)"
                      style="width: 20%"
                    >
                      <span
                        v-show="celda_activa != 'f' + index + 'c1'"
                        @click="mostrarInput(index, 1)"
                        style="width: 100%"
                        >{{ item.facturacion_promedio | dinero('$', 0) }}</span
                      >
                      <input
                        type="text"
                        v-show="celda_activa == 'f' + index + 'c1'"
                        :ref="'f' + index + 'c1'"
                        v-model="datos_roi[index].facturacion_promedio"
                        @keyup.arrow-right="finEdicionTab(index, 1)"
                        @keydown.tab.stop.prevent="finEdicionTab(index, 1)"
                        @keyup.arrow-up="finEdicionUp(index, 1)"
                        @keyup.arrow-down.enter="finEdicionDown(index, 1)"
                        @keyup.arrow-left="finEdicionLeft(index, 1)"
                        @keyup.esc="escape('f' + index + 'c1')"
                        @keypress="esNumero($event)"
                        style="width: 100%"
                      />
                    </td>
                    <td
                      class="ma-0 pa-0"
                      @click="mostrarInput(index, 2)"
                      style="width: 20%"
                    >
                      <span
                        v-show="celda_activa != 'f' + index + 'c2'"
                        @click="mostrarInput(index, 2)"
                        style="width: 100%"
                        >{{ item.cant_clientes | numero }}</span
                      >
                      <input
                        type="text"
                        v-show="celda_activa == 'f' + index + 'c2'"
                        :ref="'f' + index + 'c2'"
                        v-model="datos_roi[index].cant_clientes"
                        @keyup.arrow-right="finEdicionTab(index, 2)"
                        @keydown.tab.stop.prevent="finEdicionTab(index, 2)"
                        @keyup.arrow-up="finEdicionUp(index, 2)"
                        @keyup.arrow-down.enter="finEdicionDown(index, 2)"
                        @keyup.arrow-left="finEdicionLeft(index, 2)"
                        @keyup.esc="escape('f' + index + 'c2')"
                        @keypress="esNumero($event)"
                        style="width: 100%"
                      />
                    </td>
                    <td
                      class="ma-0 pa-0"
                      @click="mostrarInput(index, 3)"
                      style="width: 20%"
                    >
                      <span
                        v-show="celda_activa != 'f' + index + 'c3'"
                        @click="mostrarInput(index, 3)"
                        style="width: 100%"
                        >{{ item.costo_cliente | dinero('$', 0) }}</span
                      >
                      <input
                        type="text"
                        v-show="celda_activa == 'f' + index + 'c3'"
                        :ref="'f' + index + 'c3'"
                        v-model="datos_roi[index].costo_cliente"
                        @keyup.arrow-right="finEdicionTab(index, 3)"
                        @keydown.tab.stop.prevent="finEdicionTab(index, 3)"
                        @keyup.arrow-up="finEdicionUp(index, 3)"
                        @keyup.arrow-down.enter="finEdicionDown(index, 3)"
                        @keyup.arrow-left="finEdicionLeft(index, 3)"
                        @keyup.esc="escape('f' + index + 'c3')"
                        @keypress="esNumero($event)"
                        style="width: 100%"
                      />
                    </td>
                    <td
                      class="ma-0 pa-0"
                      @click="mostrarInput(index, 4)"
                      style="width: 20%"
                    >
                      <span
                        v-show="celda_activa != 'f' + index + 'c4' && index < 2"
                        @click="mostrarInput(index, 4)"
                        style="width: 100%"
                        >{{ item.mejora_propuesta | porcentaje }}</span
                      >
                      <input
                        type="text"
                        v-show="celda_activa == 'f' + index + 'c4' && index < 2"
                        :ref="'f' + index + 'c4'"
                        v-model="datos_roi[index].mejora_propuesta"
                        @keyup.arrow-right="finEdicionTab(index, 4)"
                        @keydown.tab.stop.prevent="finEdicionTab(index, 4)"
                        @keyup.arrow-up="finEdicionUp(index, 4)"
                        @keyup.arrow-down.enter="finEdicionDown(index, 4)"
                        @keyup.arrow-left="finEdicionLeft(index, 4)"
                        @keyup.esc="escape('f' + index + 'c4')"
                        @keypress="esNumeroPorc($event)"
                        style="width: 100%"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col align-self="center">
            <v-card>
              <v-simple-table dense light>
                <template v-slot:default>
                  <thead style="background-color: #3fa9be; color: white;">
                    <tr>
                      <th class="text-center" style="color: white !important;">
                        Situación Inicial
                      </th>
                      <th class="text-center" style="color: white !important;">
                        Mejora Esperada
                      </th>
                      <th class="text-center" style="color: white !important;">
                        Rendimiento Mensual
                      </th>
                      <th class="text-center" style="color: white !important;">
                        Rendimiento Anual
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="ma-0 pa-0 text-center">
                        {{ sit_inicial | dinero('$', 0) }}
                      </td>
                      <td class="mr-1 pa-0 text-center">
                        {{ mejora_esperada | dinero('$', 0) }}
                      </td>
                      <td class="ml-1 pa-0 text-center">
                        {{ (mejora_esperada - sit_inicial) | dinero('$', 0) }}
                      </td>
                      <td class="ma-0 pa-0 text-center">
                        {{
                          ((mejora_esperada - sit_inicial) * 12)
                            | dinero('$', 0)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0 caption"
        align="stretch"
        height="auto"
      >
        Si querés saber más sobre lo que hacemos en BleCX y cómo podemos
        ayudarte con tu negocio o empresa contactate con nosotros
        <a
          href="http://www.blecx.com.ar/#contacto"
          aria-current="page"
          target="_blank"
          rel="noopener noreferrer"
          >aquí</a
        >
      </v-card>
    </v-col>

    <v-col cols="12" md="6">
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline"
          >¿Qué relación hay entre CX y ROI ?</v-card-title
        >
        <v-card-subtitle class="text-justify"
          >Si partimos de entender la voz del cliente, y transformamos las
          experiencias en función a disminuir o eliminar los gaps entre sus
          expectativas y lo que realmente vive en cada interacción, estaremos
          impactando directamente en la mejora de plazos, calidad y costos. Este
          impacto afecta directamente el ROI.</v-card-subtitle
        >
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mb-2">
        <v-card-title class="headline"
          >¿Para qué sirve esta calculadora?</v-card-title
        >
        <v-card-subtitle class="text-justify"
          >El desafío de la mayoría de los profesionales de CX es calcular
          correctamente el ROI de la experiencia, en los diversos negocios y
          contextos actuales. Existen muchos modelos, y queremos compartirte el
          que utilizamos. Vas a poder entender el impacto de los esfuerzos de
          transformar las experiencias de los clientes, y estimar el impacto en
          el negocio y en la proyección del ROI.</v-card-subtitle
        >
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mb-2">
        <v-card-title class="headline"
          >¿Cómo se usa la calculadora?</v-card-title
        >
        <v-card-subtitle class="text-justify">
          Tenés que completar los siguientes datos para cada grupo:
          <br />1- la cantidad de clientes (o una muestra representativa).
          <br />2- facturación promedio mensual por cliente. <br />3- el costo
          mensual por cliente. <br />4- el porcentaje de clientes de un grupo
          que queremos llevar al siguiente, es decir, de detractores a neutros o
          de neutros a promotores. Para promotores no se ingresa este dato.
          <br />
          <br />Probando luego diferentes escenarios de mejora posible, lo que
          se traduce en convertir detractores a neutros y neutros a promotores,
          se obtiene la estimación de proyección de ROI.
        </v-card-subtitle>
        <v-card-text>
          <a
            href="https://www.blecx.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-img
              src="../assets/logo.svg"
              width="80"
              align="bottom"
              class="ml-auto"
            ></v-img>
          </a>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      celda_activa: '',
      datos_roi: [
        {
          nps: 'Detractores',
          facturacion_promedio: null,
          cant_clientes: null,
          costo_cliente: null,
          mejora_propuesta: null,
        },
        {
          nps: 'Neutros',
          facturacion_promedio: null,
          cant_clientes: null,
          costo_cliente: null,
          mejora_propuesta: null,
        },
        {
          nps: 'Promotores',
          facturacion_promedio: null,
          cant_clientes: null,
          costo_cliente: null,
          mejora_propuesta: null,
        },
      ],
    };
  },
  filters: {
    dinero: function(value, currency, decimals) {
      //if (!value) return "$0";
      //return "$ " + parseInt(value).toLocaleString();
      var digitsRE = /(\d{3})(?=\d)/g;
      value = parseFloat(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      currency = currency != null ? currency : '$';
      decimals = decimals != null ? decimals : 2;
      var stringified = Math.abs(value).toFixed(decimals);
      var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
      var i = _int.length % 3;
      var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? '.' : '') : '';
      var _float = decimals ? stringified.slice(-1 - decimals) : '';
      var sign = value < 0 ? '-' : '';
      return (
        sign + currency + head + _int.slice(i).replace(digitsRE, '$1.') + _float
      );
    },
    numero: function(value) {
      value = parseInt(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      return value;
    },
    porcentaje(val) {
      return ((val * 1).toFixed(2) + '%').replace('.', ',');
    },
  },

  methods: {
    mostrarInput(fila, columna) {
      var referencia = `f${fila}c${columna}`;
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    finEdicionTab(fila, columna) {
      var prox_fila = fila < 2 && columna == 4 ? fila + 1 : fila;
      var prox_columna =
        fila == 2 && columna == 3
          ? 3
          : columna == 4 && fila != 2
          ? 1
          : columna == 4
          ? 4
          : columna + 1;
      var referencia = `f${prox_fila}c${prox_columna}`;
      this.finEdicion(referencia);
    },
    finEdicionUp(fila, columna) {
      var prox_fila = fila > 0 ? fila - 1 : 0;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicionDown(fila, columna) {
      var prox_fila =
        fila == 1 && columna == 4 ? fila : fila < 2 ? fila + 1 : 2;
      var referencia = `f${prox_fila}c${columna}`;
      if (fila == 1 && columna == 4) {
        this.escape(referencia);
      } else {
        this.finEdicion(referencia);
      }
    },
    finEdicionLeft(fila, columna) {
      var prox_fila = fila > 0 && columna == 1 ? fila - 1 : fila;
      var prox_columna =
        columna == 1 && fila != 0 ? 4 : columna == 1 ? 1 : columna - 1;
      var referencia = `f${prox_fila}c${prox_columna}`;
      this.finEdicion(referencia);
    },
    finEdicion(referencia) {
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    escape(referencia) {
      this.celda_activa = '';
      this.$nextTick(() => {
        this.$refs[referencia][0].blur();
      });
    },
    esNumero(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 41 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    esNumeroPorc(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var nuevoValor = parseFloat(
        evt.target.value + String.fromCharCode(charCode)
      );
      var hayPunto = evt.target.value.toString().indexOf('.');
      if (
        (hayPunto != -1 && charCode == 46) ||
        nuevoValor > 100.0 ||
        (charCode > 41 && (charCode < 48 || charCode > 57) && charCode !== 46)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },

  computed: {
    sit_inicial: function() {
      var d_f_p = this.datos_roi[0]['facturacion_promedio']
        ? parseFloat(this.datos_roi[0]['facturacion_promedio'])
        : 0;
      var d_co_cl = this.datos_roi[0]['costo_cliente']
        ? parseFloat(this.datos_roi[0]['costo_cliente'])
        : 0;
      var d_ca_cl = this.datos_roi[0]['cant_clientes']
        ? parseFloat(this.datos_roi[0]['cant_clientes'])
        : 0;

      var n_f_p = this.datos_roi[1]['facturacion_promedio']
        ? parseFloat(this.datos_roi[1]['facturacion_promedio'])
        : 0;
      var n_co_cl = this.datos_roi[1]['costo_cliente']
        ? parseFloat(this.datos_roi[1]['costo_cliente'])
        : 0;
      var n_ca_cl = this.datos_roi[1]['cant_clientes']
        ? parseFloat(this.datos_roi[1]['cant_clientes'])
        : 0;

      var p_f_p = this.datos_roi[2]['facturacion_promedio']
        ? parseFloat(this.datos_roi[2]['facturacion_promedio'])
        : 0;
      var p_co_cl = this.datos_roi[2]['costo_cliente']
        ? parseFloat(this.datos_roi[2]['costo_cliente'])
        : 0;
      var p_ca_cl = this.datos_roi[2]['cant_clientes']
        ? parseFloat(this.datos_roi[2]['cant_clientes'])
        : 0;

      var valor_detractores = (d_f_p - d_co_cl) * d_ca_cl;
      var valor_neutros = (n_f_p - n_co_cl) * n_ca_cl;
      var valor_promotores = (p_f_p - p_co_cl) * p_ca_cl;

      return valor_detractores + valor_neutros + valor_promotores;
    },
    mejora_esperada: function() {
      var d_f_p = this.datos_roi[0]['facturacion_promedio']
        ? parseFloat(this.datos_roi[0]['facturacion_promedio'])
        : 0;
      var d_co_cl = this.datos_roi[0]['costo_cliente']
        ? parseFloat(this.datos_roi[0]['costo_cliente'])
        : 0;
      var d_m_p = this.datos_roi[0]['mejora_propuesta']
        ? parseFloat(this.datos_roi[0]['mejora_propuesta'])
        : 0;
      var d_ca_cl = this.datos_roi[0]['cant_clientes']
        ? parseFloat(this.datos_roi[0]['cant_clientes'])
        : 0;
      var d_cl_mejora = d_ca_cl - (d_ca_cl * d_m_p) / 100.0;

      var n_f_p = this.datos_roi[1]['facturacion_promedio']
        ? parseFloat(this.datos_roi[1]['facturacion_promedio'])
        : 0;
      var n_co_cl = this.datos_roi[1]['costo_cliente']
        ? parseFloat(this.datos_roi[1]['costo_cliente'])
        : 0;
      var n_m_p = this.datos_roi[1]['mejora_propuesta']
        ? parseFloat(this.datos_roi[1]['mejora_propuesta'])
        : 0;
      var n_ca_cl = this.datos_roi[1]['cant_clientes']
        ? parseFloat(this.datos_roi[1]['cant_clientes'])
        : 0;
      var n_cl_mejora =
        n_ca_cl - (n_ca_cl * n_m_p) / 100.0 + (d_ca_cl * d_m_p) / 100.0;

      var p_f_p = this.datos_roi[2]['facturacion_promedio']
        ? parseFloat(this.datos_roi[2]['facturacion_promedio'])
        : 0;
      var p_co_cl = this.datos_roi[2]['costo_cliente']
        ? parseFloat(this.datos_roi[2]['costo_cliente'])
        : 0;
      var p_ca_cl = this.datos_roi[2]['cant_clientes']
        ? parseFloat(this.datos_roi[2]['cant_clientes'])
        : 0;
      var p_cl_mejora = p_ca_cl + (n_ca_cl * n_m_p) / 100.0;

      var valor_detractores = (d_f_p - d_co_cl) * d_cl_mejora;
      var valor_neutros = (n_f_p - n_co_cl) * n_cl_mejora;
      var valor_promotores = (p_f_p - p_co_cl) * p_cl_mejora;

      return valor_detractores + valor_neutros + valor_promotores;
    },
  },
};
</script>

<style>
.activa {
  background-color: #eaf0f6;
}
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
} /* solución a los títulos de vcard que se cortan las palabras a la mitad */
</style>
*/
